import { Component } from '@angular/core';
import { ComponentsEnum } from 'src/app/common/enum/components-enum';
import { UpdateMetaService } from 'src/app/common/service/meta-service.service';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrl: './platform.component.scss'
})
export class PlatformComponent {
  componentsEnum: typeof ComponentsEnum = ComponentsEnum;
  loadedComponents: Set<ComponentsEnum> = new Set();

  constructor(
    private updateMetaService: UpdateMetaService,
  ) {
    // this.updateMetaService.updateMetaTags('Platform');
  }

  loadComponent(componentType: ComponentsEnum): void {
    this.loadedComponents.add(componentType);
  }

  isComponentLoaded(componentType: ComponentsEnum): boolean {
    return this.loadedComponents.has(componentType);
  }
}
